/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
(function () {
'use strict';

angular.module('bulbApp.permissionsModule')
/**
 * BulbShareableLinkService handles for generating the shareable links for the page.
 */
.service('BulbShareableLinkService', ['$q', 'Restangular', 'BulbAuthService', 'BulbUnitService', 'BulbBusyService', BulbShareableLinkService]);

function BulbShareableLinkService($q, Restangular, BulbAuthService, BulbUnitService, BulbBusyService) {

  var that = this;
  that.unit = BulbUnitService.currentUnit;
  this.currentUserRestrictions = BulbAuthService.currentUser.features;
  that.selectedVisibilityChoices = [];

  /**
   * Generate the private shareable Links.
   * @returns {shareableLink}
   */
  this.generateShareableLink = function () {

    var deferred = $q.defer();

    Restangular.one('units', that.unit.id ? that.unit.id : that.parentUnitId).customPOST({}, 'shareableLink')
      .then(function (resUnit) {

        that.unit.shareableLink = resUnit.shareableLink;

        return deferred.resolve(that.unit.shareableLink);
      });

    return BulbBusyService.showBusyDuring(deferred.promise);
  };
}
})();
